App.TagsFilterItemComponent = Em.Component.extend
  classNames: ['tags-filter-item']
  clientTag: null
  classNameBindings: ['isChecked', 'isEdit']

  isEdit: false

  isChecked: (->
    @get('clientTag.id') in @get('selectedTags')
  ).property('clientTag', 'selectedTags.[]')

  click: ->
    if not @get('isEdit')
      @sendAction('onCheck', @get('clientTag'))

  actions:
    focusOut: ->
      clientTag = @get('clientTag')

      return unless clientTag.get('isDirty')

      if Ember.isEmpty(clientTag.get('name'))
        clientTag.rollback()
      else
        clientTag.save()

    destroyTag: ->
      clientTag = @get('clientTag')

      # todo i18n
      if confirm("Вы действительно хотите удалить тег - #{clientTag.get('name')}?")
        clientTag.destroyRecord(=>
          @sendAction('onCheck', clientTag)
        )
